import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from './ui/card';
import { Hotel, Ticket, MapPin, Shield, Car, ArrowRight, Sparkles } from 'lucide-react';

const ICONS = { hotels: Hotel, experiences: Ticket, guides: MapPin, transfers: Car, insurance: Shield };

export const DestinationContextPanel = ({ context, modules }) => {
  if (!context?.destination_city) return null;
  return (
    <Card className="p-5 rounded-2xl border-border" data-testid="destination-context-panel">
      <div className="flex items-center gap-2 text-accent mb-1">
        <Sparkles className="h-4 w-4" />
        <span className="text-xs font-semibold uppercase tracking-wide">Going to {context.destination_city}?</span>
      </div>
      <h3 className="font-display font-semibold text-lg mb-4">Complete your {context.destination_city} trip</h3>
      <div className="space-y-2">
        {modules?.map((m) => {
          const Icon = ICONS[m.key] || ArrowRight;
          const disabled = m.href === '#';
          const inner = (
            <div className={`flex items-center gap-3 rounded-xl border border-border px-3 py-2.5 ${disabled ? 'opacity-50' : 'hover:bg-secondary hover:border-accent/30'} transition-colors`}>
              <span className="grid place-items-center h-8 w-8 rounded-lg bg-accent/10 text-accent"><Icon className="h-4 w-4" /></span>
              <span className="text-sm font-medium flex-1">{m.title}</span>
              {!disabled && <ArrowRight className="h-4 w-4 text-muted-foreground" />}
            </div>
          );
          return disabled ? <div key={m.key}>{inner}</div>
            : <Link key={m.key} to={m.href} data-testid={`cross-sell-${m.key}`}>{inner}</Link>;
        })}
      </div>
    </Card>
  );
};
